import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAddReplyKey, getPostKey, POSTS_KEY, FEED_KEY, } from '../../utils/keys';
import { addPostToPaginatedPost, postRepliesUpdater, infinitePostUpdater, infinitePostArrayUpdater, } from '../cache/useCachedPost';
import { pinnedPostsFilter } from './filters';
const onAddReply = (variables, newPost, queryClient) => {
    const { postId } = variables;
    /** Add the reply to the parent post.replies query */
    const rootPostKey = getPostKey(postId);
    const rootPostSnapshot = queryClient.getQueryData(rootPostKey);
    if (rootPostSnapshot) {
        queryClient.setQueryData(rootPostKey, postRepliesUpdater(newPost));
    }
    /**
     * Add the reply to the replies queries
     * (inactive/disabled queries are the replies to reply ones so we also update them to show the feedback)
     * */
    const repliesKey = {
        queryKey: POSTS_KEY,
        predicate: query => {
            var _a;
            const [main, args] = query.queryKey || [];
            return main === POSTS_KEY && ((_a = args) === null || _a === void 0 ? void 0 : _a.postId) === postId;
        },
    };
    const repliesSnapshot = queryClient.getQueriesData(repliesKey);
    if (repliesSnapshot) {
        queryClient.setQueriesData(repliesKey, addPostToPaginatedPost(newPost));
    }
    /** Add reply to the pinned posts */
    const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
    if (pinnedPostsSnapshot) {
        queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(postId, postRepliesUpdater(newPost), false)));
    }
    /**  Add the reply to Post.replies in any posts/feed queries which the parent post exists */
    // get all active posts query
    const postsQueryFilter = {
        active: true,
        predicate: query => {
            var _a;
            const [main, args] = (query === null || query === void 0 ? void 0 : query.queryKey) || [];
            if (((_a = args) === null || _a === void 0 ? void 0 : _a.postId) !== postId &&
                (main === FEED_KEY || main === POSTS_KEY)) {
                return true;
            }
            return false;
        },
    };
    // take a snapshot from all matched posts queries
    const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
    // update replies within the found post everywhere (posts and the feed queries)
    queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(postId, postRepliesUpdater(newPost), false));
    return {
        postsSnapshots,
        rootPostSnapshot,
        repliesSnapshot,
        pinnedPostsSnapshot,
    };
};
export const useAddReply = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const addReplyKey = getAddReplyKey();
    return useMutation((input) => client.posts.reply(input.postId, input, fields), {
        mutationKey: addReplyKey,
        onSuccess: (data, variables) => {
            onAddReply(variables, data, queryClient);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddReply.js.map